import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/index/productSafe.png';
import _imports_1 from '@/assets/img/index/codeSafe.png';
import _imports_2 from '@/assets/img/index/safeKnowledge.png';
import _imports_3 from '@/assets/img/index/knowledgeQA.png';
import _imports_4 from '@/assets/img/index/riskCodeInterpreAnalysis.png';
import _imports_5 from '@/assets/img/index/fuzzingCode.png';
import _imports_6 from '@/assets/img/index/personGrowUp.png';
import _imports_7 from '@/assets/img/index/defectCodeSuggets.png';
import _imports_8 from '@/assets/img/index/sastCode.png';
import _imports_9 from '@/assets/img/index/reportExport.png';
import _imports_10 from '@/assets/img/index/loopPoc.png';
import _imports_11 from '@/assets/img/index/scaCode.png';
import _imports_12 from '@/assets/img/index/safetyResearch.png';
import _imports_13 from '@/assets/img/index/vulThreatIntelAnalysis.png';
import _imports_14 from '@/assets/img/index/binarySystemCode.png';
const _withScopeId = n => (_pushScopeId("data-v-13726f77"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "agent-box"
};
const _hoisted_2 = {
  class: "agent-menu"
};
const _hoisted_3 = {
  class: "agent-top"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img-icon",
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "智能体", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img-icon",
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "智能体", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img-icon",
  src: _imports_2,
  alt: ""
}, null, -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "智能体", -1));
const _hoisted_10 = {
  class: "agent-content"
};
const _hoisted_11 = {
  class: "content-group"
};
const _hoisted_12 = {
  class: "content-tips"
};
const _hoisted_13 = {
  key: 0,
  src: _imports_3,
  alt: ""
};
const _hoisted_14 = {
  key: 1
};
const _hoisted_15 = {
  key: 2,
  src: _imports_4,
  alt: ""
};
const _hoisted_16 = {
  key: 3
};
const _hoisted_17 = {
  key: 4,
  src: _imports_5,
  alt: ""
};
const _hoisted_18 = {
  key: 5
};
const _hoisted_19 = {
  class: "content-tips"
};
const _hoisted_20 = {
  key: 0,
  src: _imports_6,
  alt: ""
};
const _hoisted_21 = {
  key: 1
};
const _hoisted_22 = {
  key: 2,
  src: _imports_7,
  alt: ""
};
const _hoisted_23 = {
  key: 3
};
const _hoisted_24 = {
  key: 4,
  src: _imports_8,
  alt: ""
};
const _hoisted_25 = {
  key: 5
};
const _hoisted_26 = {
  class: "content-tips"
};
const _hoisted_27 = {
  key: 0,
  src: _imports_9,
  alt: ""
};
const _hoisted_28 = {
  key: 1
};
const _hoisted_29 = {
  key: 2,
  src: _imports_10,
  alt: ""
};
const _hoisted_30 = {
  key: 3
};
const _hoisted_31 = {
  key: 4,
  src: _imports_11,
  alt: ""
};
const _hoisted_32 = {
  key: 5
};
const _hoisted_33 = {
  class: "content-tips"
};
const _hoisted_34 = {
  key: 0,
  src: _imports_12,
  alt: ""
};
const _hoisted_35 = {
  key: 1
};
const _hoisted_36 = {
  key: 2,
  src: _imports_13,
  alt: ""
};
const _hoisted_37 = {
  key: 3
};
const _hoisted_38 = {
  key: 4,
  src: _imports_14,
  alt: ""
};
const _hoisted_39 = {
  key: 5
};
const _hoisted_40 = {
  class: "buttom-box"
};
import ButtomCom from '@/components/buttomCom.vue';
import { ref, onMounted } from 'vue';
export default {
  __name: 'agentMenu',
  setup(__props) {
    let activeId = ref(3);
    let timer = ref();
    const changeAgent = val => {
      clearInterval(timer.value);
      timer.value = null;
      activeId.value = val;
    };
    const setTime = () => {
      if (!timer.value) {
        timer.value = setInterval(() => {
          if (activeId.value === 1) {
            activeId.value = 3;
          } else {
            activeId.value--;
          }
        }, 3000);
      }
    };
    const jumpPage = url => {
      // 获取当前页面地址
      url = `${url}?trackCode=${window.location.href.split('//')[1]}`;
      window.open(url);
    };
    onMounted(() => {
      setTime();
    });
    return (_ctx, _cache) => {
      const _directive_lazy = _resolveDirective("lazy");
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
        class: _normalizeClass(_unref(activeId) === 3 ? 'agent-cell-active' : 'agent-cell'),
        onMouseenter: _cache[0] || (_cache[0] = _withModifiers($event => changeAgent(3), ["stop"])),
        onMouseleave: _withModifiers(setTime, ["stop"])
      }, [_hoisted_4, _createTextVNode("安全工具型 "), _hoisted_5], 34), _createElementVNode("div", {
        class: _normalizeClass(_unref(activeId) === 2 ? 'agent-cell-active mr' : 'agent-cell mr'),
        onMouseenter: _cache[1] || (_cache[1] = _withModifiers($event => changeAgent(2), ["stop"])),
        onMouseleave: _withModifiers(setTime, ["stop"])
      }, [_hoisted_6, _createTextVNode(" 代码安全类 "), _hoisted_7], 34), _createElementVNode("div", {
        class: _normalizeClass(_unref(activeId) === 1 ? 'agent-cell-active mr' : 'agent-cell mr'),
        onMouseenter: _cache[2] || (_cache[2] = _withModifiers($event => changeAgent(1), ["stop"])),
        onMouseleave: _withModifiers(setTime, ["stop"])
      }, [_hoisted_8, _createTextVNode("安全知识类 "), _hoisted_9], 34)]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_unref(activeId) === 1 ? (_openBlock(), _createElementBlock("img", _hoisted_13)) : _createCommentVNode("", true), _unref(activeId) === 1 ? (_openBlock(), _createElementBlock("p", _hoisted_14, "安全通用知识问答")) : _createCommentVNode("", true), _unref(activeId) === 2 ? (_openBlock(), _createElementBlock("img", _hoisted_15)) : _createCommentVNode("", true), _unref(activeId) === 2 ? (_openBlock(), _createElementBlock("p", _hoisted_16, "风险代码解释分析")) : _createCommentVNode("", true), _unref(activeId) === 3 ? (_openBlock(), _createElementBlock("img", _hoisted_17)) : _createCommentVNode("", true), _unref(activeId) === 3 ? (_openBlock(), _createElementBlock("p", _hoisted_18, "智能模糊测试")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_19, [_unref(activeId) === 1 ? (_openBlock(), _createElementBlock("img", _hoisted_20)) : _createCommentVNode("", true), _unref(activeId) === 1 ? (_openBlock(), _createElementBlock("p", _hoisted_21, "人才培养与竞赛赋能")) : _createCommentVNode("", true), _unref(activeId) === 2 ? (_openBlock(), _createElementBlock("img", _hoisted_22)) : _createCommentVNode("", true), _unref(activeId) === 2 ? (_openBlock(), _createElementBlock("p", _hoisted_23, "缺陷代码修复建议")) : _createCommentVNode("", true), _unref(activeId) === 3 ? (_openBlock(), _createElementBlock("img", _hoisted_24)) : _createCommentVNode("", true), _unref(activeId) === 3 ? (_openBlock(), _createElementBlock("p", _hoisted_25, "软件智能静态分析")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_26, [_unref(activeId) === 1 ? (_openBlock(), _createElementBlock("img", _hoisted_27)) : _createCommentVNode("", true), _unref(activeId) === 1 ? (_openBlock(), _createElementBlock("p", _hoisted_28, "安全报告与方案生成")) : _createCommentVNode("", true), _unref(activeId) === 2 ? (_openBlock(), _createElementBlock("img", _hoisted_29)) : _createCommentVNode("", true), _unref(activeId) === 2 ? (_openBlock(), _createElementBlock("p", _hoisted_30, "漏洞PoC辅助生成")) : _createCommentVNode("", true), _unref(activeId) === 3 ? (_openBlock(), _createElementBlock("img", _hoisted_31)) : _createCommentVNode("", true), _unref(activeId) === 3 ? (_openBlock(), _createElementBlock("p", _hoisted_32, "软件智能成分分析")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_33, [_unref(activeId) === 1 ? (_openBlock(), _createElementBlock("img", _hoisted_34)) : _createCommentVNode("", true), _unref(activeId) === 1 ? (_openBlock(), _createElementBlock("p", _hoisted_35, "前沿安全研究解读")) : _createCommentVNode("", true), _unref(activeId) === 2 ? (_openBlock(), _createElementBlock("img", _hoisted_36)) : _createCommentVNode("", true), _unref(activeId) === 2 ? (_openBlock(), _createElementBlock("p", _hoisted_37, "漏洞威胁情报分析")) : _createCommentVNode("", true), _unref(activeId) === 3 ? (_openBlock(), _createElementBlock("img", _hoisted_38)) : _createCommentVNode("", true), _unref(activeId) === 3 ? (_openBlock(), _createElementBlock("p", _hoisted_39, "二进制智能安全分析")) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_40, [_createVNode(ButtomCom, {
        btnName: "免费试用",
        isArrow: true,
        onClick: _cache[3] || (_cache[3] = $event => jumpPage('/bookDemoPage.html'))
      })])])])])), [[_directive_lazy, require('@/assets/img/index/number-bg.png'), "background-image"]]);
    };
  }
};